import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'classHours'
})
export class ClassHoursPipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate, classificationEstimateId: string) {
    let total = 0;

    for (const estimateLine of departmentEstimate.estimateLines) {
      for (const classificationLine of estimateLine.classificationLines) {
        if (classificationLine.classificationEstimateId === classificationEstimateId) total += classificationLine.hours;
      }
    }

    return total;
  }
}
